// src/screens/Reconcile/ReconcileSummary.js
import React, { useContext } from 'react';
import CountContext from '../../context/CountContext.js';

export default function ReconcileSummary({ onNext, onBack }) {
  const { state } = useContext(CountContext);
  const { rolls, writtenTipConfirmed, report, tipBucket, drawerCoins } = state;

  // Calculate total value of rolls
  const rollsValue =
    rolls.quarters * 10 +
    rolls.dimes * 5 +
    rolls.nickels * 2 +
    rolls.pennies * 0.5;

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">Reconciliation Summary</h2>
      <ul className="list-disc ml-6 space-y-2">
        <li><strong>Rolls Value:</strong> ${rollsValue.toFixed(2)}</li>
        <li><strong>Written Tips Confirmed:</strong> {writtenTipConfirmed ? 'Yes' : 'No'}</li>
        <li><strong>Credit Tips:</strong> ${report.creditTips.toFixed(2)}</li>
        <li><strong>Total Charges:</strong> ${report.totalCharges.toFixed(2)}</li>
        <li><strong>Gift Card Payment:</strong> ${report.giftCardPayment.toFixed(2)}</li>
        <li><strong>Total Sales:</strong> ${report.totalSales.toFixed(2)}</li>
        <li><strong>Total Minus Gift:</strong> ${report.totalMinusGift.toFixed(2)}</li>
        <li><strong>Total Tax:</strong> ${report.totalTax.toFixed(2)}</li>
        <li><strong>Tip-Bucket Coins:</strong> ${tipBucket.coins.toFixed(2)}</li>
        <li><strong>Tip-Bucket Bills:</strong> ${tipBucket.bills.toFixed(2)}</li>
        <li><strong>Drawer Coins Reading:</strong> ${drawerCoins.toFixed(2)}</li>
      </ul>
      <div className="mt-6 flex space-x-4">
        <button onClick={onBack} className="px-4 py-2 bg-gray-300 rounded">
          Back
        </button>
        <button onClick={onNext} className="px-4 py-2 bg-blue-500 text-white rounded">
          Confirm Summary
        </button>
      </div>
    </div>
  );
}
